import routeConstant from "./routeConstant";

const pathConstant = {
    [routeConstant.DEFAULT_PAGE]: "Landing Page",
    [routeConstant.LOGIN_PAGE]: "Login Page",
    [routeConstant.SIGNUP_PAGE]: "Signup Page",
    [routeConstant.VERIFY_OTP_PAGE]: "Verify OTP Page",
    [routeConstant.CREATE_PASSWORD_PAGE]: "Create Password Page",
    [routeConstant.RESET_PASSWORD_PAGE]: "Reset Password Page",
    [routeConstant.FORGOT_PASSWORD_PAGE]: "Forgot Password Page",
    [routeConstant.SELECT_SPORT_PAGE]: "Select Sport Page",
    [routeConstant.PAGE_NOT_FOUND]: "Page Not Found",
    [routeConstant.CART_PAGE]: "Cart Page",
    [routeConstant.MY_ACCOUNT_PAGE]: "My Account Page",
    [routeConstant.SPORT_PAGE]: "Sport Page",
    [routeConstant.DEPLOY_TOKEN_PAGE]: "Deploy Token Page",
    [routeConstant.PAYMENT_PAGE]: "Payment Page",
    [routeConstant.MY_CONTACT]: "My Contact Info",
    [routeConstant.MY_PURCHASE]: "My Purchase History",
    [routeConstant.MY_COLLECTIBLES]: "My Colle ctibles",
    [routeConstant.SCORE_GAME_PAGE]: "Score Game Page",

    // Other Pages
    [routeConstant.PRIVACY]: "Privacy Page",
    [routeConstant.TERMS]: "Terms Page",
    [routeConstant.COOKIES]: "Cookies Page",
};

export default pathConstant;
